/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ResultWithTotal as OkEgisServiceBusinessResultWithTotal } from '../models/OK/Egis/Service/Business/result-with-total';
import { RecentEftersynDto as OkEgisServiceModelsDtoRecentEftersynDto } from '../models/OK/Egis/Service/Models/DTO/recent-eftersyn-dto';
import { RecentServiceafregningDto as OkEgisServiceModelsDtoRecentServiceafregningDto } from '../models/OK/Egis/Service/Models/DTO/recent-serviceafregning-dto';
import { StartAfregningRequest as OkEgisServiceModelsRequestStartAfregningRequest } from '../models/OK/Egis/Service/Models/Request/start-afregning-request';

@Injectable({
  providedIn: 'root',
})
export class SystemStatusService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation startAfregning
   */
  static readonly StartAfregningPath = '/api/v1/SystemStatus/StartAfregning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startAfregning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startAfregning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestStartAfregningRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.StartAfregningPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `startAfregning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startAfregning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestStartAfregningRequest
  }): Observable<void> {

    return this.startAfregning$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getRecentAfregninger
   */
  static readonly GetRecentAfregningerPath = '/api/v1/SystemStatus/GetRecentAfregninger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecentAfregninger()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecentAfregninger$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentServiceafregningDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetRecentAfregningerPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentServiceafregningDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRecentAfregninger$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecentAfregninger(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoRecentServiceafregningDto>> {

    return this.getRecentAfregninger$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentServiceafregningDto>>) => r.body as Array<OkEgisServiceModelsDtoRecentServiceafregningDto>)
    );
  }

  /**
   * Path part for operation getWaitingPartnerServiceordreafregning
   */
  static readonly GetWaitingPartnerServiceordreafregningPath = '/api/v1/SystemStatus/GetWaitingPartnerServiceordreafregning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingPartnerServiceordreafregning()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingPartnerServiceordreafregning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetWaitingPartnerServiceordreafregningPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWaitingPartnerServiceordreafregning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingPartnerServiceordreafregning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.getWaitingPartnerServiceordreafregning$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation geAfregningerWithoutBilag
   */
  static readonly GeAfregningerWithoutBilagPath = '/api/v1/SystemStatus/GeAfregningerWithoutBilag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `geAfregningerWithoutBilag()` instead.
   *
   * This method doesn't expect any request body.
   */
  geAfregningerWithoutBilag$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GeAfregningerWithoutBilagPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `geAfregningerWithoutBilag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  geAfregningerWithoutBilag(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.geAfregningerWithoutBilag$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation getWaitingCustomerServiceordreafregning
   */
  static readonly GetWaitingCustomerServiceordreafregningPath = '/api/v1/SystemStatus/GetWaitingCustomerServiceordreafregning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingCustomerServiceordreafregning()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCustomerServiceordreafregning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetWaitingCustomerServiceordreafregningPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWaitingCustomerServiceordreafregning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCustomerServiceordreafregning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.getWaitingCustomerServiceordreafregning$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation getWaitingPartnerkreditering
   */
  static readonly GetWaitingPartnerkrediteringPath = '/api/v1/SystemStatus/GetWaitingPartnerkreditering';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingPartnerkreditering()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingPartnerkreditering$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetWaitingPartnerkrediteringPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWaitingPartnerkreditering$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingPartnerkreditering(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.getWaitingPartnerkreditering$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation getWaitingCustomerOpkraevning
   */
  static readonly GetWaitingCustomerOpkraevningPath = '/api/v1/SystemStatus/GetWaitingCustomerOpkraevning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingCustomerOpkraevning()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCustomerOpkraevning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetWaitingCustomerOpkraevningPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWaitingCustomerOpkraevning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingCustomerOpkraevning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.getWaitingCustomerOpkraevning$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation getRecentEftersyn
   */
  static readonly GetRecentEftersynPath = '/api/v1/SystemStatus/GetRecentEftersyn';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRecentEftersyn()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecentEftersyn$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentEftersynDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetRecentEftersynPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentEftersynDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRecentEftersyn$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRecentEftersyn(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoRecentEftersynDto>> {

    return this.getRecentEftersyn$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoRecentEftersynDto>>) => r.body as Array<OkEgisServiceModelsDtoRecentEftersynDto>)
    );
  }

  /**
   * Path part for operation getWaitingEftersynCreated
   */
  static readonly GetWaitingEftersynCreatedPath = '/api/v1/SystemStatus/GetWaitingEftersynCreated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaitingEftersynCreated()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingEftersynCreated$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetWaitingEftersynCreatedPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getWaitingEftersynCreated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaitingEftersynCreated(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceBusinessResultWithTotal> {

    return this.getWaitingEftersynCreated$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceBusinessResultWithTotal>) => r.body as OkEgisServiceBusinessResultWithTotal)
    );
  }

  /**
   * Path part for operation getNextScheduledEftersynCreation
   */
  static readonly GetNextScheduledEftersynCreationPath = '/api/v1/SystemStatus/GetNextScheduledEftersynCreation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNextScheduledEftersynCreation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextScheduledEftersynCreation$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetNextScheduledEftersynCreationPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNextScheduledEftersynCreation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextScheduledEftersynCreation(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<string> {

    return this.getNextScheduledEftersynCreation$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getNextScheduledOpkraevning
   */
  static readonly GetNextScheduledOpkraevningPath = '/api/v1/SystemStatus/GetNextScheduledOpkraevning';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNextScheduledOpkraevning()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextScheduledOpkraevning$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SystemStatusService.GetNextScheduledOpkraevningPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNextScheduledOpkraevning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNextScheduledOpkraevning(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<string> {

    return this.getNextScheduledOpkraevning$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
